import { z } from 'zod';
import { postRequest } from './amplify/helpers';
import { SourceMediaAsset, MediaAssetType } from '@/types/media';
import { RangeResponse } from './paginationTypes';

export enum SearchFilterName {
  type = 'type',
  text = 'text',
  source = 'source',
  tagged = 'tagged',
  products = 'products',
  uploadType = 'uploadType',
  labels = 'labels',
  tags = 'tags',
  owner = 'owner',
  suggestedProducts = 'suggestedProducts',
  appExternalId = 'appExternalId',
  date = 'date',
}

export enum TypeFilterValues {
  video = 'video',
  image = 'image',
}

export type PlayAppMediaAsset = SourceMediaAsset & {
  id: string;
  source: string;
};

export type PlayAppMediaAssetResponse = RangeResponse<PlayAppMediaAsset>;

export const GetPlayAppMediaAssetsSchema = z.object({
  appKey: z.string().min(1),
  type: z.enum([MediaAssetType.image, MediaAssetType.video]).optional(),
  from: z.number().int().positive(),
  size: z.number().int().positive(),
  textQuery: z.string().optional(),
  source: z.string().optional(),
});

export type GetPlayAppMediaAssetsRequest = z.infer<typeof GetPlayAppMediaAssetsSchema>;

export const getPlayAppMedia = async (request: GetPlayAppMediaAssetsRequest): Promise<PlayAppMediaAssetResponse> => {
  return postRequest({
    apiName: 'studio',
    path: '/play-media/list',
    options: {
      body: request,
    },
  });
};
